module.exports = __webpack_public_path__ + "img/join_2.cd3b35f3.jpg";